<template>
    <div>
      <br />
      <a href="/qa.html" target="_blank">よくある質問</a>
      <br />
      <a href="javascript:void(0)" @click="goManshonRegist">わんにゃんメイト申込フォーム</a>
      <br />
      <a href="javascript:void(0)" @click="goInquary">問い合わせ</a>
    </div>
  </template>
  
  <script>
  export default {
    name: 'HomePage',
    methods: {
      goManshonRegist() {
        this.$router.push({ path: '/manshonRegist' }).catch(() => {});
      },
      goInquary() {
        this.$router.push({ path: '/inquary' }).catch(() => {});
      }
    }
  };
  </script>